import React, { useContext, useCallback } from 'react';

import { Button, Label, Card } from '@ergeon/core-components';
import { PlusIcon } from '@ergeon/icons/hero/micro';

import { ModalController } from '../../modals';
import DialerModal from '../../modals/DialerModal';
import { TwilioContext } from '../../context-providers/TwilioContext';
import { CallHistoryContext } from '../../context-providers/CallHistoryContext';
import { useCallDisconnectListener } from '../../hooks/useCallDisconnectListener';

import CallsListContent from './CallsListContent';

type CallsListerProps = {
  selectedCallId?: number;
};

const CallsLister: React.FC<CallsListerProps> = ({ selectedCallId }) => {
  const { calls } = useContext(TwilioContext);
  const { callHistory, isLoading, hasMore, loadMore } = useContext(CallHistoryContext);

  useCallDisconnectListener();

  const handleLoadMore = useCallback(async() => {
    if (!isLoading && hasMore) {
      try {
        await loadMore();
      } catch {
        // Errors are handled silently
      }
    }
  }, [isLoading, hasMore, loadMore]);

  const onDial = () => {
    ModalController.show(DialerModal);
  };

  return (
    <Card className="flex flex-col w-full overflow-hidden shrink-0" tag="aside" zIndex="1">
      <div className="flex justify-between items-start p-4">
        <Label>Recent Calls</Label>
        <Button
          aria-label="Open dialing pad"
          className="whitespace-nowrap"
          flavor="primary"
          onClick={onDial}
          size="small"
          taste="line"
          title="Start a New Call">
          <PlusIcon className="size-4 shrink-0" />
          New Call
        </Button>
      </div>
      <CallsListContent
        activeCalls={calls}
        callHistory={callHistory}
        hasMore={hasMore}
        isLoading={isLoading}
        onLoadMore={handleLoadMore}
        selectedCallId={selectedCallId} />
    </Card>
  );
};

export default CallsLister;
